import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight, ExternalLink } from 'lucide-react';
import { Certification } from '../data/certifications';
interface CertificationCardProps {
  card: Certification;
}
export function CertificationCard({
  card
}: CertificationCardProps) {
  return <div className="bg-white border border-steel-200 rounded-sm overflow-hidden hover:border-cg-orange-600 transition-colors group flex flex-col" data-id="element-77">
      {/* Logo/Thumbnail */}
      <div className="h-32 bg-white flex items-center justify-center border-b border-steel-100 p-4" data-id="element-78">
        {card.logo ? <img src={card.logo} alt={card.title} className="max-h-20 max-w-full object-contain" data-id="element-79" /> : <ShieldCheck className="w-12 h-12 text-steel-300 group-hover:text-cg-orange-600 transition-colors" data-id="element-80" />}
      </div>

      <div className="p-6 flex flex-col flex-1" data-id="element-81">
        <span className="text-[10px] font-bold uppercase tracking-wider text-cg-orange-600 mb-2" data-id="element-82">
          {card.type}
        </span>
        <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-83">{card.title}</h3>
        <p className="text-sm text-steel-600 mb-4 flex-1" data-id="element-84">{card.descriptor}</p>

        <div className="text-xs text-steel-500 mb-6 pb-6 border-b border-steel-100" data-id="element-85">
          <span className="font-semibold text-navy-900" data-id="element-86">
            {card.type === 'Membership' ? 'Managed by:' : 'Issued by:'}
          </span>{' '}
          {card.issuedBy}
        </div>

        <div className="flex flex-col gap-4 mt-auto" data-id="element-87">
          {card.externalLink ? <a href={card.externalLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider text-sm rounded-sm transition-colors w-full gap-2" data-id="element-88">
              Learn more <ExternalLink className="w-4 h-4" data-id="element-89" />
            </a> : <Link to={`/about/certifications/${card.id}`} className="inline-flex items-center justify-center px-6 py-3 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider text-sm rounded-sm transition-colors w-full gap-2" data-id="element-90">
              View details <ArrowRight className="w-4 h-4" data-id="element-91" />
            </Link>}
        </div>
      </div>
    </div>;
}